import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import green from '@material-ui/core/colors/green'
import TickInside from '../assets/tick_inside.png'
import PaymentBalance from './success/PaymentBalance'
import ShareLinks from './success/ShareLinks'

class Success extends React.Component {
  gotoHome = () => {
    const { bookingInfo: { edp: url }, additionalGuests } = this.props
    if (additionalGuests) {
      window.location.href = url
    } else {
      window.location.reload()
    }
  }

  render() {
    const { classes, translate, additionalGuests, bookingInfo, propertyInfo, propertyName } = this.props
    const buttonLabel = additionalGuests
      ? translate('forwardToNextGuestLabel')
      : translate('nextLabel')

    return (
      <Grid container>
        <Grid item xs={12} style={{ marginTop: 10, textAlign: 'center' }}>
          <img src={TickInside} alt="tick" height="100" width="100" />
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'center', marginLeft: 5, marginRight: 5 }}>
          <Typography component="h4" variant="h4">
            {translate('successTitle')}
          </Typography>
          <Typography component="h4" variant="h4">
            {translate('successSubTitle')}
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'center', marginTop: 20, marginLeft: 5, marginRight: 5 }}>
          <Typography component="h6" variant="h6">
            {translate('successText')}
          </Typography>
        </Grid>

        <PaymentBalance
          ccPaymentAmount={bookingInfo.cc_payment_amount}
          checkinOnlinePaymentActive={propertyInfo.checkin_online_payment}
        />

        <Grid item xs={12} style={{ textAlign: 'center', marginTop: 40, marginLeft: 5, marginRight: 5 }}>
          <Typography variant="subtitle2">
            {translate('checkinOtherGuestsMessage')}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            className={classNames(classes.margin, classes.cssRoot)}
            onClick={this.gotoHome}
          >
            {buttonLabel}
          </Button>
        </Grid>

        <ShareLinks url={bookingInfo.edp} propertyName={propertyName} />
      </Grid>
    )
  }
}

Success.propTypes = {
  classes: PropTypes.object.isRequired
}

const styles = (theme) => ({
  margin: {
    margin: theme.spacing(4),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cssRoot: {
    color: '#fff',
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    }
  }
})

export default compose(withStyles(styles), connect())(withTranslate(Success))
